/**
 * Created with IntelliJ IDEA.
 * User: aadams
 * Date: 05.03.13
 * Time: 10:08
 * To change this template use File | Settings | File Templates.
 */

import { IBasicGGSTextField } from "../IBasicGGSTextField";
import { GGSTextFieldSignal } from "./GGSTextFieldSignal";

import TextEvent = createjs.TextEvent;

export class TextInputSignal extends GGSTextFieldSignal {
    constructor() {
        super();
        this.mappedEventType = TextEvent.TEXT_INPUT;
    }

    public dispatchTyped(basicTextField: IBasicGGSTextField): void {
        super.dispatch(basicTextField);
    }
}
